import React from 'react';
import {
  Card as NextUICard,
  CardHeader as NextUICardHeader,
  CardBody as NextUICardBody,
  CardFooter as NextUICardFooter,
  CardProps as NextUICardProps,
  HTMLNextUIProps,
} from '@nextui-org/react';

interface CardProps extends NextUICardProps {
  href?: string;
}

export function Card(props: CardProps) {
  return (
    <NextUICard
      classNames={{
        base: ['shadow-none', 'border-1', 'bg-default-100', 'border-default-100', 'p-2'],
        header: [],
        body: [],
        footer: [],
      }}
      {...props}
    >
      {props.children}
    </NextUICard>
  );
}

export function CardHeader(props: HTMLNextUIProps) {
  return <NextUICardHeader {...props}>{props.children}</NextUICardHeader>;
}

export function CardBody(props: HTMLNextUIProps) {
  return <NextUICardBody {...props}>{props.children}</NextUICardBody>;
}

export function CardFooter(props: HTMLNextUIProps) {
  return <NextUICardFooter {...props}>{props.children}</NextUICardFooter>;
}
